// extracted by mini-css-extract-plugin
export default {"checkout_summary":"Ms","checkout_summary_wrapper":"Ns","summary_items":"Os","line_items_wrapper":"Ps","separator":"Qs","order_summary":"Rs","line_item":"Ss","order__summary_item_title":"Ts","recurringdis":"Us","note":"Vs","carbon_emission":"Ws","unlock_savings":"Xs","member_perk":"Ys","info":"Zs","no_items":"at","promo":"bt","order_summary_mobile":"ct","open_summary_mobile":"et","fixed_bottom_info":"ft","open_info":"gt","text":"ht","open_summary":"it"};
    if(module.hot) {
      // 1730991502438
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  